import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  Login,
  RolUsers,
  Empresa,
  Sede,
  LoginSaved,
  Cargo
} from '@app/shared';

@Injectable()
export class CreateUserLoginDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Agrega un login al sitema
   *
   * @param {Login} user
   * @returns {Observable<LoginSaved>}
   * @memberof CreateUserLoginDataService
   */
  addUserLogin(user: LoginSaved): Observable<Login> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
       .post<Login>(this.api.get('usersManagement'), user).subscribe(
        newUser => {
          obs.next(newUser);
          this.toastr.success('Login de usuario creado correctamente', 'Operación exitosa');
        },
        err => {
          if (err.error.username) {
            this.toastr.error(err.error.username, 'Error de operación');
          } else {
            this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operación');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Actualiza un login del sistema
   *
   * @param {number} id
   * @param {Login} user
   * @returns {Observable<boolean>}
   * @memberof CreateUserLoginDataService
   */
  updateUserLogin(id: number, user: LoginSaved): Observable<boolean> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
       .put<boolean>(this.api.get('usersManagement', [id]), user).subscribe(
        update => {
          obs.next(update);
          this.toastr.success('Login de usuario actualizado correctamente', 'Operación exitosa');
        },
        err => {
          if (err.error.username) {
            this.toastr.error(err.error.username, 'Error de operación');
          } else {
            this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operación');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Retorna un login en especifico con us grupos a los que pertenece
   *
   * @param {number} id
   * @returns {Promise<Login>}
   * @memberof CreateUserLoginDataService
   */
  getUserLogin(id: number): Promise<Login> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
       .get<Login>(this.api.get('usersManagement', [id])).subscribe(
        user => {
          resolve(user);
        },
        err => {
          this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operación');
          reject(err);
        }
      );
    });
  }

  /**
   * Retorna los grupos del sistema
   *
   * @returns {Observable<RolUsers[]>}
   * @memberof CreateUserLoginDataService
   */
  getRoles(): Observable<RolUsers[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
       .get<RolUsers[]>(this.api.get('rolesUsers')).subscribe(
        roles => {
          obs.next(roles);
        },
        err => {
          this.toastr.error('Lo sentimos ha ocurrido un error', 'Error de operación');
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta las empresas del sistema
   *
   * @returns {Observable<Empresa[]>}
   * @memberof CreateUserLoginDataService
   */
  getCompanies(): Observable<Empresa[]> {
    return new Observable(obs => {
      this.http.get<Empresa[]>(this.api.get('company')).subscribe(
        companies => {
          obs.next(companies);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta las sedes de una empresa
   *
   * @param {number} idCompany
   * @returns {Observable<Sede[]>}
   * @memberof CreateUserLoginDataService
   */
  getSedes(idCompany: number): Observable<Sede[]> {
    return new Observable(obs => {
      this.http.get<Sede[]>(this.api.get('sedesManagement', [idCompany])).subscribe(
        sedes => {
          obs.next(sedes);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta los cargos del sistema
   *
   * @param {number} idSedes
   * @returns {Observable<Cargo[]>}
   * @memberof CreateUserLoginDataService
   */
  getCharges(): Observable<Cargo[]> {
    return new Observable(obs => {
      this.http.get<Cargo[]>(this.api.get('chargeUsers')).subscribe(
        charges => {
          obs.next(charges);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/create-user-login/shared/create-user-login.data.service.ts